<template>
  <div class="page_content module_course" aria-label="Create Course section Page Content">
    <div class="row page-heading">
      <div class="col-8 input module_heading">
        <span class="module_icon icon-course"></span>
        <b-form-input id="title" type="text"
          v-model.trim="model.title" :state="titleState"
          placeholder="Type in the Course title*"
          aria-label="type in the Course title"
          aria-describedby="titleFeedback" v-focus>
        </b-form-input>
        <b-form-invalid-feedback id="titleFeedback">
          Title must not be empty
        </b-form-invalid-feedback>
      </div>
      <div class="btn-container col-4">
        <template>
          <button class="btn-cancel" @click="cancel">
          <span class="icon-cross" aria-label="cancel"></span>
          </button>
          <button class="btn btn-primary" @click="onSubmit(true)" aria-label="done">done</button>
          <button class="btn btn-primary" @click="onSubmit(false)" aria-label="save">save</button>
        </template>
      </div>
    </div>
    <div class="row page-content">
      <div class="col-3 thumbnail_panel ace_sec" aria-label="Thumbnail Section">
        <div class="thumbnail_container d-flex ace_sec_txt">
          <div class="d-flex align-items-center justify-content-center">
              <img v-if="thumbnail" id="majorMinorThumbnail" :src="thumbnail">
              <span class="icon-photo" v-else>{{thumbnail}}</span>
              <b-btn @click="addThumbnailClicked">edit</b-btn>
          </div>
        </div>
        <div class="mb-4 py-3">
          <div class="page_section_row row pl-4 mb-2">
            <label for="folder" class="ace_sec_txt" id="folderName">Folder</label>
          </div>
          <div class="page_section_row row pl-4 mb-2">
            <select id="folder" v-model="model.owningLibraryId" aria-labelledby="folderName" style="width: 100%;">
              <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-7 left-spacer ace_sec">
        <div class="page-section">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="description" class="ace_sec_txt" id="folderName">Course Description</label>
            </div>
            <div class="value fld_input_desc">
              <editor api-key="no-api-key"
                v-model.trim="model.description"
                :init="({
                  base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
                  selector: 'textarea',
                  menubar: false,
                  plugins: plugins,
                  toolbar: toolbar,
                  branding: false,
                  statusbar: false,
                  end_container_on_empty_block: true
                })"
                @onInit="handlerInit"
                id="courseDescriptionId">
                </editor>
            </div>
          </div>
          <div class="page_section_row min-content">
            <div class="heading">
              <label for="coursetype" class="ace_sec_txt">Course Type</label>
            </div>
            <div class="value page_content_block">
              <div class="row fld_row">
                <div class="col-12 fld_input pr-5">
                  <select id="courseType"  v-model="model.courseType" aria-labelledby="courseType">
                    <option v-for="option in courseTypes" v-bind:value="option">
                      {{ getCourseTypeLabel(option) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="page_section_row min-content">
            <div class="heading">
              <label class="ace_sec_txt" for="roomInformation">Course Catalog External ID</label>
            </div>
            <div class="value page_content_block">
              <div class="row fld_row">
                <div class="col-12 fld_input pr-5">
                  <input
                    type="text"
                    class="lms-course-field"
                    placeholder="type in the course catalog ID"
                    v-model.trim="model.catalogCourseExternalId">
                  </div>
                </div>
            </div>
          </div>
          <div class="page_section_row" v-if="isSisIntegrationEnable">
            <div class="heading">
              <label for="sisCourseId" class="ace_sec_txt">SIS Integration</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">SIS Course ID </label>
                    </div>
                    <div class="col-6 fld_input">
                      <input
                        type="text"
                        id="sisCourseId"
                        class="lms-course-field"
                        placeholder="type in the SIS Course ID"
                        v-model.trim="model.sisCourseId">
                      </div>
                    </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">SIS Section ID </label>
                    </div>
                    <div class="col-6 fld_input">
                      <input
                        type="text"
                        id="sisCourseSectionId"
                        class="lms-course-field"
                        placeholder="type in the SIS Section ID"
                        v-model.trim="model.sisCourseSectionId">
                      </div>
                    </div>
               </div>
             </div>
             <div class="row mt-3">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Max Seats </label>
                    </div>
                    <div class="col-6 fld_val">
                      <input
                        type="text"
                        id="maxSeats"
                        class="lms-course-field"
                        placeholder="type in the maximum seats allowed"
                        v-model.trim="model.maxSeats">
                      </div>
                    </div>
               </div>
               <div class="col-6">
                 <div class="row fld_row">
                   <div class="col-5 fld_label">
                     <label class="ace_sec_txt">Term </label>
                   </div>
                   <div class="col-6 fld_input">
                     <select v-model="model.termCode">
                       <option :value="key" v-for="(key, value) in institution.semesterMap">{{value}}</option>
                     </select>
                   </div>
                 </div>
              </div>

              </div>
            </div>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label for="lmsCourseId" class="ace_sec_txt">LMS Integration</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">LMS Course ID </label>
                    </div>
                    <div class="col-6 fld_val">
                      <input
                        type="text"
                        id="lmsCourseId"
                        class="lms-course-field"
                        placeholder="type in the LMS Course ID"
                        v-model.trim="model.lmsCourseCourseId">
                      </div>
                    </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">LMS Section ID </label>
                    </div>
                    <div class="col-6 fld_val">
                      <input
                        type="text"
                        id="lmsCourseId"
                        class="lms-course-field"
                        placeholder="type in the LMS Section ID"
                        v-model.trim="model.lmsCourseId">
                      </div>
                    </div>
               </div>

                <div class="col-6 pt-3">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Enable SSO </label>
                    </div>
                    <div class="col-6 checkbox_container fld_val">
                      <input type="checkbox" id="checkbox" aria-labelledby="Enable SSO" v-model="model.enableSSO">
                      </div>
                    </div>
                </div>
                <div class="col-6 pt-3">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">LTI 1.3 Enabled</label>
                    </div>
                    <div class="col-6 checkbox_container fld_val">
                      <input type="checkbox" id="checkbox" aria-labelledby="LTI 1.3 Enabled" v-model="model.ltiCourse">
                      </div>
                    </div>
                </div>

              </div>
            </div>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label for="duration" class="ace_sec_txt">Observation Deadline </label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Show Deadline</label>
                    </div>
                    <div class="col-6 checkbox_container fld_input">
                      <input type="checkbox" id="checkbox" aria-labelledby="Show Deadline" v-model="model.showDeadLine">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Duration</label>
                    </div>
                    <div class="col-6 fld_input">
                      <select id="duration"  v-model="model.duration" aria-labelledby="duration">
                        <option v-for="option in durationTypes" v-bind:value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
               </div>
              </div>
            </div>
          </div>
          <div class="page_section_row"  >
            <div class="heading">
              <label for="duration" class="ace_sec_txt">Additional Settings</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Archive : </label>
                    </div>
                    <div class="col-6 checkbox_container fld_input">
                      <input type="checkbox" id="checkbox" aria-labelledby="Archived" v-model="model.archived">
                    </div>
                  </div>
                </div>
                <div class="col-6" v-if="isSectionChannelEnabled">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Create Channel</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Pre Message" v-model="model.createChannel">
                    </div>
                  </div>
                </div>
                <div class="col-6 mt-4" v-if="institution.sendItemAnalysisReport">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Send Item Analysis Report</label>
                    </div>
                    <div class="col-6 checkbox_container fld_input">
                      <input type="checkbox" id="checkbox" aria-labelledby="Send Item Analysis Report" v-model="model.sendItemAnalysisReportCourse">
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label class="ace_sec_txt" for="roomInformation">Score to Students</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Disabled (Hidden)</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-label="Score to Students" v-model="model.hideScoreForStudent">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label class="ace_sec_txt" for="roomInformation">Manually/Automatically Validate Resource Links</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Check Broken Links</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-label="Check Broken Links" v-model="model.checkBrokenLinks">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row" v-if="isLLMContentEnabled">
            <div class="heading">
              <label class="ace_sec_txt" for="pragyaAI">Pragya AI</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Enable LLM content</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-label="Enable LLM content" v-model="model.supportAIContent">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label class="ace_sec_txt" for="playerConfig">Include Topic in course flow</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Description </label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Description" v-model="model.includeCDesc">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">AI Content </label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="AI Content" v-model="model.includeCAI">
                    </div>
                  </div>
                </div>
                <div class="col-6 mt-4">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Pre Message</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Pre Message" v-model="model.includePreMessage">
                    </div>
                  </div>
                </div>
                <div class="col-6 mt-4">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Post Message</label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Post Message" v-model="model.includePostMessage">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page_section_row">
            <div class="heading">
              <label class="ace_sec_txt" for="playerConfig">Course Dashboard Settings</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Show Progress </label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Show Progress" v-model="model.showProgress">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Show Announcements </label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Show Announcements" v-model="model.showAnnouncements">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Menu To Instructor </label>
                    </div>
                    <div class="col-6 fld_input checkbox_container">
                      <input type="checkbox" id="checkbox" aria-labelledby="Show Progress" v-model="model.menuToInstructor">
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <div class="page_section_row clo clo-content" v-if="isMCReady">
            <div class="heading">
              <label for="description" class="ace_sec_txt">Competencies</label>
            </div>
            <div class="value page_content_block">
              <div class="clo-section">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <template v-for="mc in microcompetencies">
                    <span class="clo-box ace_sec_txt" v-b-popover.hover="mc.description" :title="mc.code" v-bind:aria-label="mc.code" @mouseover="competencyPopover" @mouseleave="closeCompetencyPopover">{{mc.code}}</span>
                  </template>
                </div>
              </div>
            </div>
            <div>
              <a href="javascript:void(0)" class="more-link show-more float-right mt-1" @click="expandCollapseClo" style="display:none;">more</a>
              <a href="javascript:void(0)" class="more-link show-less float-right mt-1" @click="expandCollapseClo" style="display:none;">less</a>
            </div>
          </div>

          <div class="page_section_row clo clo-content">
            <div class="heading">
              <label class="ace_sec_txt">Tags</label>
            </div>
            <div class="value page_content_block" style="float: left; width: 97%; margin-bottom: 30px;">
              <div class="clo-section" style="overflow: visible;">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <div class="tag-list-section" v-if="isTagsAvailable()">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="(values, key, i) in model.appliedTagMap">
                          <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                          <span class="tag_name instructional_tag">{{tag.name}}</span>
                          </span>
                        </template>
                      </div>
                      <!--
                        <span class="tag-box ellipsisTags" @click="showAddTagPopup($event)">
                            <span class="tag-box-content ace_sec_txt"> ... </span>
                        </span>
                        -->
                    </div>
                    <button type="button" title="edit tag" class="icon-edit" @click="showAddTagPopup($event)"></button>
                  </div>
                  <div class="no-tags" v-else @click="showAddTagPopup($event)">
                    <div class="tag-box-list">
                      <a href="javascript:void(0)" class="ace_sec_txt float-left" style="margin-top: 15px;">click to add tags</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>

          <div class="page_section_row">
            <div class="heading">
              <label class="ace_sec_txt" for="roomInformation">Location</label>
            </div>
            <div class="value page_content_block">
              <div class="row fld_row">
                <div class="col-12 fld_input pr-5">
                  <input
                    type="text"
                    id="roomInformation"
                    class=""
                    placeholder="type in the room information"
                    v-model.trim="model.roomInformation">
                  </div>
                </div>
            </div>
          </div>

          <div class="page_section_row credits-section">
            <div class="heading">
              <label class="ace_sec_txt">{{creditLabel}}s</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Min {{creditLabel}} </label>
                    </div>
                    <div class="col-6 fld_input">
                      <input
                        type="number"
                        id="minCredit"
                        class=""
                        :placeholder="'type in the min ' + creditLabel.toLowerCase()"
                        v-model.trim="model.minCredit" size="sm">
                      </div>
                    </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt">Max {{creditLabel}} </label>
                    </div>
                    <div class="col-6 fld_input pr-5">
                      <b-form-input id="maxCredit" type="number"
                        v-model.trim="model.maxCredit" :state="maxCreditState"
                        :placeholder="'type in the max ' + creditLabel.toLowerCase()"
                        aria-describedby="maxCreditFeedback"
                        class="" size="sm">
                      </b-form-input>
                    </div>
                  </div>
                  <b-form-invalid-feedback id="maxCreditFeedback">
                    Max {{creditLabel}} must be equal or heigher than Min {{creditLabel}}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
          <div class="page_section_row credits-section">
            <div class="heading">
              <label class="ace_sec_txt">Duration</label>
            </div>
            <div class="value page_content_block">
              <div class="row">
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt" for="startDate">Start Date</label>
                    </div>
                    <div class="col-6 fld_input">
                      <datepicker id="startDate" v-model="model.startDate" name="uniquename" :disabledDates="disabledDates" @selected="validateStartDate"></datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row fld_row">
                    <div class="col-5 fld_label">
                      <label class="ace_sec_txt" for="endDate">End Date</label>
                    </div>
                    <div class="col-6 fld_input">
                      <datepicker id="endDate" v-model="model.endDate" name="uniquename" :disabledDates="disabledDates" aria-describedby="endDateFeedback" @selected="validateEndDate"></datepicker>
                    </div>
                    <div class="col-12">
                      <b-form-invalid-feedback id="endDateFeedback">
                        End Date must be on or after Start Date
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="create-course-help-modal">
      <b-modal ref="createCourseSectionHelpModal" :title="'Creating a Section from a Master'" :header-bg-variant="'course-create-help-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="content-section">
          <span>
          Please use the menu on the left to navigate between various details of
          the course that you are creating. At this time, you can fill in the &#34;About&#34;
          and &#34;Content&#34; details of the course by clicking on the respective tabs. You
          can fill in the name of the course at the top left.
          </span>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="icon"></div>
          <div class="popup-heading">Creating a Section from a Master</div>
          <button type="button" class="btn_close" style="float: right;" @click="closeQuickHelpModal">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="closeQuickHelpModal" class="btn button-primary float-right mr-2"> ok </b-button>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
    <div class="hidden-container">
      <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
        <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
      </form>
    </div>
    <div>
      <b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
        <div slot="modal-header" class="popover-header">
          <div class="popup-heading">Update Thumbnail</div>
            <button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
              <span class="ic-close"></span>
            </button>
          </div>
          <div class="row">

            <div class="col-4">
              <div class="thumbnail_msg">How your thumbnail will appear</div>
              <div class="thumbnail_container">
                <b-btn v-if="isUploadingThumbnail || (thumbnailURI && thumbnailURI.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove thumbnail</b-btn>
                <img v-if="thumbnailURI" id="majorMinorThumbnail" :src="thumbnailURI">
                <span v-else class="ic ic-majorMinor" style="font-size: 98px; height: 98px;"></span>
              </div>
            </div>


             <div class="col-7 right-model-box">
              <div class="row fld_row">
                <div class="col-1 fld_col_label">
                  <label>URL</label>
                </div>
                <div class="col-8 fld_col_input">
                  <input :id="newThumbnailUrl" :disabled="isUploadingThumbnail" v-model="thumbnailURI" placeholder="http://"></input>
                </div>
                <div class="col-3 btn_container">
                </div>
             </div>


                 <div class="row fld_row msg_row">
                    <div class="col-1"></div>
                    <div class="col-11 msg">Add image url for thumbnail.</div>
                  </div>
                  <div class="row txt_sep_row">
                    <div class="col-12">OR</div>
                 </div>


                 <div class="row fld_row">
                    <div class="col-1 fld_col_label">
                      <label for="newThumbnailFileName">File</label>
                    </div>
                    <div class="col-8 fld_col_input">
                      <input id="newThumbnailFileName" disabled v-model="thumbnail" placeholder="choose a file from your computer"></input>
                    </div>
                    <div class="col-3 fld_col_btn">
                      <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
                    </div>
                  </div>


                  <div class="row msg_row">
                    <div class="col-1"></div>
                    <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
                  </div>
                </div>
          </div>
          <div slot="modal-footer">
                <b-btn @click="addNewThumbnail">save and next</b-btn>
                <b-btn @click="cancelAddThumbnail">cancel</b-btn>
          </div>

      </b-modal>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import AddTagPopup from '../../tagging/components/AddTagPopup'
import Datepicker from 'vuejs-datepicker'
import { PACKAGE } from '../../../package_constants'
import DataLossPrompt from '../../common/components/DataLossPrompt'
import Editor from '@tinymce/tinymce-vue'
import _ from 'lodash'
import { AwsObject } from '../aws'

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    console.log('creating file: ', file)
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
    // added
    // this.uri = file.uri
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})

var EntityData = function (id, title, type, contentFileType, fileType) {
  this.id = id
  this.uuid = undefined
  this.uri = undefined
  this.title = title
  this.type = type
  this.action = undefined
  this.thumbnail = undefined
  this.isDataRendered = false
  this.isStudentEditable = false
  this.children = []
  this.contentFileType = contentFileType
  this.fileType = fileType
  this.html = undefined
  this.originUuid = undefined
}

var DisableDate = function (startDate) {
  const date = (startDate) ? new Date(startDate) : new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export default {
  name: 'course-section-create',
  props: ['sourceId', 'uuid'],
  components: {
    CourseNav,
    Datepicker,
    AddTagPopup,
    DataLossPrompt,
    Editor
  },
  data: () => {
    return {
      plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
      toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
      courseTypes: ['SUGGESTION_PLUS_BASED', 'BASIC', 'OPEN'],
      durationTypes: ['Select One', '14 Weeks', '28 Weeks', '32 Weeks', '30 Weeks-Tx-Intership', '13 Weeks-Tx-Clinical','30 Weeks AZ'],
      showAddThumbnailModal: false,
      isUploadingThumbnail : false,
      newThumbnailUrl: '',
      thumbnailURI : '',
      thumbnailURICopy : '',
      thumbnailCopy : '',
      showAddThumbnailModal: false,
      fileUploadArray: [],
      errors: [],
      owningLibrary: {},
      isEditingThumbnail: false,

      model: {
        title: ' ',
        description: undefined,
        lmsCourseId: undefined,
        lmsCourseCourseId: undefined,
        sisCourseId : undefined,
        sisCourseSectionId: undefined,
        thumbnail : '',
        maxSeats: 0,
        enableSSO : false,
        ltiCourse : false,
        showDeadLine: false,
        sendItemAnalysisReportCourse: false,
        createChannel: false,
        archived: false, 
        hideScoreForStudent : false,
        checkBrokenLinks : false,
        supportAIContent : false,
        includeCAI : false,
        showAnnouncements: false,
        showProgress: false,
        menuToInstructor: false,
        includePre : false,
        includePreMessage : false,
        includePostMessage : false,
        courseType: 'SUGGESTION_PLUS_BASED',
        duration: 'Select One',
        minCredit: 0,
        maxCredit: 0,
        startDate: undefined,
        endDate: undefined,
        roomInformation: undefined,
        appliedTagMap: {},
        owningLibraryId: undefined,
        termCode: ''
      },
      plan: [],
      folders: [],
      entityType: {
        TOPIC: 'LearningTopic',
        ASSET: 'LearningContent'
      },
      disabledDates: {
        to: new DisableDate()
      },
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      isMCReady: false,
      taggingEntityData: {},
      isShowTagPopup: false,
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1),
      nextPage: undefined,
      dirty: false,
      oldModel: {}
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.dirty) {
      this.nextPage = next
      this.$refs.dataLossAlert.showPrompt()
      next(false)
    } else {
      next()
    }
  },

  mounted () {
    if (this.uuid) {
      this.loadCourse()
    } else {
      this.loadCopyCourse()
    }
    this.loadPermission().then(res => {
      this.populateLibrary()
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })

    })
  },

  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'microcompetencies': state => state.course.microcompetencies,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'institution': state => state.institution.institution,
      'currentEnvironment': state => state.learningContent.currentEnvironment
    }),

    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    isSisIntegrationEnable () {
      let sisIntegrationFeature = this.enabledFeatures['sis_integration']
      return sisIntegrationFeature && sisIntegrationFeature.enabled
    },
    isLLMContentEnabled (){
      let contentToolsFeature = this.enabledFeatures['Content Tools']
      if (contentToolsFeature) {
        let flags = contentToolsFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Enable LLM content') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isSectionChannelEnabled() {
      let channelFeature = this.enabledFeatures['channels']
      if (channelFeature) {
        let flags = channelFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Enable course section channel') {
            return flags[i].enabled
          }
        }
      }
      return false
    },

    titleState () {
      return this.model.title.length > 0
    },

    maxCreditState () {
      return Number(this.model.minCredit) <= Number(this.model.maxCredit)
    },

    endDateState () {
      var start = (this.model.startDate) ? new Date(this.model.startDate) : new Date()
      var end = (this.model.endDate) ? new Date(this.model.endDate) : new Date()
      return start.getTime() <= end.getTime()
    }
  },

  updated () {
    // this.showEllipsisTags()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.showEllipsisTags()
      })
    })
  },

  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'loadCopyCourseDetail',
      'saveCourseDetail',
      'loadCourseDetail',
      'loadMicroCompetencies',
      'loadCourseTopics',
      'loadPermission',
      'uploadContentAndGetUri',
      'loadCurrentEnvironment',
      'updateFileUriAndVersionIdAfterS3Upload'
    ]),

    handlerInit (ev, editor) {
      $('#courseDescriptionId_ifr').css({width: '100%', height: '250px', border: '1px solid #ccc'})
    },

    closeQuickHelpModal () {
      this.$refs.createCourseSectionHelpModal.hide()
      $('#title').select()
    },

    getCourseTypeLabel (courseType) {
      if (courseType === 'SUGGESTION_SUPPLEMENT_BASED' || courseType === 'SUGGESTION_PLUS_BASED' || courseType === 'SUGGESTION_BASED') {
        return 'Problem Based Learning'
      } else if (courseType === 'BASIC') {
        return 'Competency Based Learning'
      } else {
        return 'Topic Based Learning'
      }
    },

    createNewEntity (item) {
      if (item) {
        var type = this.entityType.TOPIC
        if (item.resourceType === 'learningcontent' || item.objectType === 'LearningContent' || item.resourceType === 'lmscontent' || item.objectType === 'lmscontent' || item.type === 'LearningContent') {
          type = this.entityType.ASSET
        }
        var id = this.entityId++
        var entity = new EntityData(id, item.title, type, item.contentFileType, item.fileType)
        if (item.uuid) {
          entity.uuid = item.uuid
        }
        if (item.externalId) {
          entity.externalId = item.externalId
        }
        if (item.importedExportedSynced) {
          entity.importedExportedSynced = item.importedExportedSynced
        }
        if (item.uri) {
          entity.uri = item.uri
        }
        if (item.thumbnail) {
          entity.thumbnail = item.thumbnail
        }
        if (item.embedlyHtml) {
          entity.html = item.embedlyHtml
        }
        if (item.description) {
          entity.description = item.description
        }
        if (item.originUuid) {
          entity.originUuid = item.originUuid
        }
        if (item.ancestor) {
          entity.ancestor = item.ancestor
        }
        if (item.owningLibraryId) {
          entity.owningLibraryId = item.owningLibraryId
        }
        if (item.studentEditable) {
          entity.isStudentEditable = item.studentEditable
        }
        entity.customType = item.type
        if (item.fileSize) {
          entity.fileSize = item.fileSize
        }
        if (item.appliedTagMap) {
          var appliedTagMap = item.appliedTagMap
          entity.appliedTagMap = appliedTagMap
        }
        if (item.maxAttempt) {
          entity.maxAttempt = item.maxAttempt
        }
        if (item.localPractice) {
          entity.localPractice = item.localPractice
        }
        if (item.creationTime) {
          entity.creationTime = item.creationTime
        }
        return entity
      }
    },

    renderPlan (plan, data, action) {
      if (plan) {
        $.each(plan, (index, item) => {
          var newEntity = this.createNewEntity(item)
          if (action) {
            newEntity.action = action
          }
          if (newEntity.type === this.entityType.TOPIC) {
            newEntity.isDataRendered = true
          }
          data.push(newEntity)
          if ((item.objectType === this.entityType.TOPIC) && item.plan) {
            this.renderPlan(JSON.parse(item.plan), newEntity.children, action)
          }
        })
      }
    },

    loadCopyCourse () {
      this.loadCopyCourseDetail(this.sourceId).then(res => {
        if (res) {
          this.model.title = res.title
          this.model.courseType = res.courseType
          this.model.duration = res.duration
          this.model.description = res.description
          this.model.masterCourseId = res.masterCourseId
          this.model.owningLibraryId = res.owningLibraryId
          this.model.createChannel = res.createChannel
          this.model.catalogCourseExternalId = res.catalogCourseExternalId
          if (res.appliedTagMap) {
            this.model.appliedTagMap = res.appliedTagMap
          }
          if (res.plan && res.plan.length > 0) {
            this.renderPlan(JSON.parse(res.plan), this.plan, 'COPY')
          }
        }
        this.$data.oldModel = _.cloneDeep(this.$data.model)
        $('#about').children().addClass('active')
        this.$refs.createCourseSectionHelpModal.show()
      })
    },
     addThumbnailClicked () {
        this.showAddThumbnailModal = true
        this.thumbnailURICopy = (this.thumbnailURI) ? this.thumbnailURI.slice(0) : ''
        this.thumbnailCopy = (this.thumbnail) ? this.thumbnail.slice(0) : ''
      },
      removeThumbnailClicked () {
        this.isEditingThumbnail = true
        this.thumbnailURI = ''
        this.thumbnail = ''
      },
      cancelAddThumbnail () {
        this.thumbnailURI = this.thumbnailURICopy
        this.thumbnail = this.thumbnailCopy
        this.isEditingThumbnail = false
        this.showAddThumbnailModal = false
        this.errors = []
        this.fileUploadArray = []
      },
      addNewThumbnail () {
        if (this.thumbnail !== this.thumbnailURI) {
          // user entered url instead of uploading local file, no upload necessary
          this.thumbnail = this.thumbnailURI
        } else {
          this.uploadFiles('thumbnail')
        }
        this.showAddThumbnailModal = false
        this.isEditingThumbnail = false
      },
      chooseFile () {
        $('input[type=file][id=thumbnailFileList]').click()
      },
      thumbnailToBeUploaded (ev) {
        this.fileUploadArray = []
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length || files.length <= 0) {
          return
        }
        this.thumbnailURI = files[0].name
        this.thumbnail = files[0].name
        this.prepareFileUploadArray(files)
      },
      prepareFileUploadArray (files) {
        if (files) {
          console.log('files: ', files)
          var timestamp = new Date().getTime()
          for (var i = 0; i < files.length; i++) {
            timestamp = timestamp + i
            this.addFileToUploadArray(files[i], timestamp)
          }
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        var isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
        console.log('new fileUploadArray: ', this.fileUploadArray)
      },
      uploadFiles (contentType) {
        let fileUploadArrayClone = clone(this.fileUploadArray)
        let contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          let content = fileUploadArrayClone[i]
          console.log('creating content item: ', content)
          let item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'thumbnail': content.thumbnail,
            'thumbnailURI': content.thumbnailURI
          }
          contentListToCreate.push(item)
        }
        if (contentListToCreate.length <= 0) {
          return
        }
        this.uploadContentAndGetUri({
          learningSpaceId: this.model.owningLibraryId,
          contents: contentListToCreate,
          success: this.uploadFileAfterCreateContentSuccessCallback,
          failure: this.uploadFileAfterCreateContentErrorCallback
        })
      },
      cancelClicked () {
        return this.$router.push({ name: 'majorMinorList' })
      },
      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.fileUploadArray = []
        this.showSuccessPopup()
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        }
      },
      storeFilesToS3 (filesToBeUploaded) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
            } else {
              var uri = item.uri
              if (uri.indexOf('?versionId=') === -1) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
            }
            let thumbnailData = filesToBeUploaded[0]
            this.thumbnailURI = thumbnailData.uri
            this.thumbnail = thumbnailData.uri
          })
        })
      },
      showSuccessPopup () {
        console.log('file upload successful!')
      },
    populateLibrary () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (!this.model.owningLibraryId && learningSpace.category === 'Institute_Public') {
              this.model.owningLibraryId = learningSpace.uuid
            }
          }
        }
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      })
    },

    showEllipsisTags () {
      var tagListLength = $('.tag-list-length').height()
      if (tagListLength > 34) {
        $('.ellipsisTags').show()
      } else {
        $('.ellipsisTags').hide()
      }
    },

    isTagsAvailable () {
      let values = Object.values(this.model.appliedTagMap)
      return values.find((value) => {
        return value.length > 0
      })
    },

    showAddTagPopup (event) {
      this.isShowTagPopup = true
      this.taggingEntityData = {title: this.model.title, type: 'course', appliedTagMap: this.model.appliedTagMap}
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
      }, 500)
    },

    cancel () {
      if(this.uuid){
          return this.$router.push({ name: 'courseDetail', params: {uuid: this.uuid} })
      }else{
        this.returnToDashboard()
      }
    },

    generatePlan (plan) {
      $.each(plan, (i, item) => {
        delete item.id
        if (item.type === 'LearningTopic') {
          if (item.children.length > 0) {
            this.generatePlan(item.children)
          }
        } else {
          delete item.children
          delete item.isDataRendered
          delete item.isStudentEditable
        }
      })
      return JSON.stringify(plan)
    },

    onSubmit (isDone) {
      if (this.titleState && this.maxCreditState && this.endDateState) {
        this.dirty = false
        this.$refs.loadingModal.show()
        var data = {
          master: false,
          masterCourseId: this.model.masterCourseId,
          title: this.model.title,
          description: this.model.description,
          lmsCourseId: this.model.lmsCourseId,
          lmsCourseCourseId:this.model.lmsCourseCourseId,
          sisCourseId : this.model.sisCourseId,
          maxSeats : this.model.maxSeats,
          sisCourseSectionId: this.model.sisCourseSectionId,
          thumbnail : this.thumbnail,
          enableSSO: this.model.enableSSO,
          ltiCourse: this.model.ltiCourse,
          showDeadLine : this.model.showDeadLine,
          sendItemAnalysisReportCourse : this.model.sendItemAnalysisReportCourse,
          createChannel: this.model.createChannel,
          archived: this.model.archived,
          hideScoreForStudent : this.model.hideScoreForStudent,
          checkBrokenLinks : this.model.checkBrokenLinks,
          supportAIContent : this.model.supportAIContent,
          includeCDesc : this.model.includeCDesc,
          includeCAI : this.model.includeCAI,
          showAnnouncements: this.model.showAnnouncements,
          showProgress: this.model.showProgress,
          menuToInstructor: this.model.menuToInstructor,
          includePreMessage : this.model.includePreMessage,
          includePostMessage : this.model.includePostMessage,
          courseType: this.model.courseType,
          duration: this.model.duration,
          minCredit: this.model.minCredit,
          maxCredit: this.model.maxCredit,
          startDate: this.changeDateToString(this.model.startDate),
          endDate: this.changeDateToString(this.model.endDate),
          roomInformation: this.model.roomInformation,
          appliedTagMap: this.model.appliedTagMap,
          plan: this.generatePlan(this.plan),
          owningLibraryId: this.model.owningLibraryId,
          catalogCourseExternalId: this.model.catalogCourseExternalId,
          termCode: this.model.termCode
        }
        var message = 'Section "' + this.model.title + '"'
        if (this.uuid) {
          data.uuid = this.uuid
          message += ' updated successfully.'
        } else {
          message += ' created successfully.'
        }
        this.saveCourseDetail(data).then((res) => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: message
          })
          if (isDone) {
            if (this.nextPage) {
              this.$emit('resolveNext', this.nextPage)
            } else {
              setTimeout(() => {
                this.returnToDashboard()
              }, 1000)
            }
          } else {
            const plan = JSON.parse(res.plan)
            if (plan.length > 0) {
              this.plan = []
              this.renderPlan(plan, this.plan)
            }
            this.$refs.loadingModal.hide()
            return this.$router.push({ name: 'courseSectionEdit', params: { uuid: res.uuid } })
          }
        })
      }
    },

    returnToDashboard () {
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.employerAdminHomeView) {
        return this.$router.push({ name: 'employerAdmin' })
      } else if (userPermission.advisorHomeView) {
        return this.$router.push({ name: 'advisorDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          let name = (this.isNuNavLogin) ? 'nunavAdminDashboard' : 'adminDashboard'
          return this.$router.push({ name: name })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    },

    loadCourse () {
      this.loadCourseDetail(this.uuid).then(res => {
        if (res) {
          $('#about').children().addClass('active')
          this.model.title = res.title
          this.model.owningLibraryId = res.owningLibraryId
          this.model.description = res.description
          this.model.lmsCourseId = res.lmsCourseId
          this.model.lmsCourseCourseId = res.lmsCourseCourseId
          this.model.sisCourseId = res.sisCourseId,
          this.model.sisCourseSectionId = res.sisCourseSectionId,
          this.thumbnail = res.thumbnail
          this.thumbnailURI = res.thumbnail
          this.model.maxSeats = res.maxSeats,
          this.model.enableSSO = res.enableSSO
          this.model.ltiCourse = res.ltiCourse
          this.model.showDeadLine = res.showDeadLine
          this.model.sendItemAnalysisReportCourse = res.sendItemAnalysisReportCourse
          this.model.createChannel = res.createChannel
          this.model.archived = res.archived
          this.model.hideScoreForStudent = res.hideScoreForStudent
          this.model.checkBrokenLinks = res.checkBrokenLinks
          this.model.supportAIContent = res.supportAIContent
          this.model.includeCDesc = res.includeCDesc
          this.model.includeCAI = res.includeCAI
          this.model.showAnnouncements= res.showAnnouncements
          this.model.showProgress= res.showProgress
          this.model.menuToInstructor = res.menuToInstructor
          this.model.includePreMessage = res.includePreMessage
          this.model.includePostMessage = res.includePostMessage
          this.model.courseType = res.courseType
          this.model.duration = res.duration
          this.model.minCredit = res.minCredit
          this.model.maxCredit = res.maxCredit
          this.model.startDate = this.changeDateFormat(res.startDate)
          this.model.endDate = this.changeDateFormat(res.endDate)
          this.model.roomInformation = res.roomInformation
          this.model.owningLibraryId = res.owningLibraryId
          this.model.catalogCourseExternalId = res.catalogCourseExternalId
          this.model.termCode = res.termCode
          if (res.appliedTagMap) {
            this.model.appliedTagMap = res.appliedTagMap
          }
          if (res.competencies[0]) {
            this.loadMicroCompetencies(res.competencies[0]).then(respons => {
              this.isMCReady = true
            })
          }
        }
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      })
      this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
    },

    validateStartDate (startDate) {
      if (this.model.endDate) {
        var start = new Date(startDate)
        var end = new Date(this.model.endDate)
        if (start.getTime() > end.getTime()) {
          $('#endDateFeedback').show()
          $('#endDate').addClass('is-invalid')
        } else {
          $('#endDateFeedback').hide()
          $('#endDate').addClass('is-valid')
        }
      }
    },

    validateEndDate (endDate) {
      if (this.model.startDate) {
        var end = new Date(endDate)
        var start = new Date(this.model.startDate)
        if (end.getTime() < start.getTime()) {
          $('#endDateFeedback').show()
          $('#endDate').addClass('is-invalid')
        } else {
          $('#endDateFeedback').hide()
          $('#endDate').addClass('is-valid')
        }
      }
    },

    changeDateToString (selected) {
      if (selected) {
        const date = new Date(selected)
        let mm = String(this.months[date.getMonth()])
        let dd = date.getDate()
        if (dd < 10) {
          dd = '0' + dd
        }
        let yyyy = date.getFullYear()
        let formatted = mm + dd + yyyy
        return formatted
      }
      return undefined
    },

    changeDateFormat (selected) {
      if (selected && selected.length > 0) {
        const mm = selected.slice(0, 2)
        const dd = selected.slice(2, 4)
        const yyyy = selected.slice(4)
        return mm + '/' + dd + '/' + yyyy
      }
      return selected
    },

    competencyPopover () {
      $('.clo-box').mouseover(function () {
        $('body').addClass('competency-popover')
      })
    },

    closeCompetencyPopover () {
      $('.clo-box').mouseleave(function () {
        $('body').removeClass('competency-popover')
      })
    },

    expandCollapseClo () {
      if ($('.clo').hasClass('clo-content')) {
        $('.clo').toggleClass('expandClo', 500)
      }
    },

    okLose () {
      this.$emit('resolveNext', this.nextPage)
    },

    saveAndContinue () {
      this.onSubmit(true)
    }
  },

  watch: {
    model: {
      handler () {
        this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
      },
      deep: true
    }
  }
}
</script>

<style>

    a.disabled {
        color: #dcdad1 !important;
        pointer-events: none;
    }

    .header-section {
        width: 100%;
    }

    .popup-heading {
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseSectionCreate.vue